import React, { type ReactNode } from 'react';
import { cn } from '@hero/web-lib';

export interface DrawerTab {
  id: string;
  label: string;
  render?: () => ReactNode;
}

export interface DrawerTabsProps {
  tabs: DrawerTab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

export const DrawerTabs: React.FC<DrawerTabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
}) => {
  if (tabs.length <= 1) return null;

  return (
    <div className="flex border-b shrink-0">
      {tabs.map(tab => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onTabChange(tab.id)}
          className={cn(
            'flex-1 py-2.5 text-sm font-medium text-center transition-colors',
            activeTab === tab.id
              ? 'text-primary border-b-2 border-primary'
              : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};
